import React from 'react';
import ScrollReveal from '../components/ScrollReveal';
import { useLanguage } from '../i18n/LanguageContext';

export default function Ezofis() {
  const { t } = useLanguage();
  const e = t.ezofis;

  return (
    <section id="ezofis" className="page-section bg-dark">
      <div className="container">
        <div className="ezofis-grid">
          <ScrollReveal>
            <span className="section-eyebrow ezofis-eyebrow">{e.eyebrow}</span>
            <div className="accent-line" />
            <h2 className="section-title ezofis-section-title">{e.title}</h2>
            <p className="section-sub ezofis-section-sub">
              {e.descPre}<strong style={{ color:'#fff' }}>{e.descStrong}</strong>{e.descPost}
            </p>
            <div className="ezofis-benefits">
              {e.benefits.map(b => (
                <div key={b.label} className="benefit-chip">
                  <span>{b.icon}</span>
                  <p>{b.label}</p>
                </div>
              ))}
            </div>
          </ScrollReveal>

          <ScrollReveal delay={80}>
            <div className="ezofis-modules-title">{e.modulesTitle}</div>
            <div className="modules-grid">
              {e.modules.map(m => (
                <div key={m} className="module-item">{m}</div>
              ))}
            </div>
            <div className="ezofis-deploy-note">
              {e.deployNotePre}<strong>{e.deployCloud}</strong>{e.deployMid}<strong>{e.deployOnPrem}</strong>{e.deployNotePost}
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}
